<template>
  <div class="app_container">
    <!--操作栏-->
    <div class="filter_container">
      <butn
        btntype="primary"
        title="新增"
        iconName="el-icon-plus"
        v-permission="'videoSet:save'"
        @click="$router.push('videoSet/edit')"
      ></butn>
      <butn
        v-permission="'videoSet:shareVideo'"
        :disabled="selections.length === 0 || unShareVideoSets.length > 0"
        title="共享"
        @click="oneClickShare"
      ></butn>
      <butn
        v-permission="'videoSet:shareVideo'"
        @click="oneClickShare"
        :disabled="selections.length > 0"
        title="一键共享"
        v-if="IS_SHOW_SHARED_KEY"
      ></butn>
      <BatchDeal
        :disabled="videoSetIds.length === 0"
        :batchData="batchData"
        @batchDeal="batchDeal"
        v-if="batchData.length > 0"
      />
      <ExcelImport
        btnType=""
        butnPremission="videoSet:importOffline"
        butnTitle="导入下线视频集"
        modalTitle="导入下线视频集"
        :downloadTemplate="offlineVideoSetTemplate"
        :importApi="importOfflineVideoSet"
        @importSuccess="importSuccess"
      />
      <butn
        class="m-l-10" 
        btntype="primary"
        title="导出清单"
        v-permission="'videoSet:export'"
        @click="exportExcel"
      ></butn>
      <div class="search_right">
        <Search @search="searchHandle" />
      </div>
    </div>
    <Tables
      @selection-change="selectionChange"
      :data="videoSetList"
      @change-port="changePort"
    />
    <div class="RCPagination">
      <RCPagination ref="pagination" v-model="videoSetList" :api="api" />
    </div>
    <Details />
    <Warrant @searchl="searchl" />
    <share-manage></share-manage>
    <one-click-share></one-click-share>
    <vue-qr
      ref="Qrcode"
      :bindElement="false"
      :size="300"
      :text="qrcodeItem.shareUrl || ''"
      :margin="10"
      :callback="qrCallBack"
      :qid="qrcodeItem.uuid"
    />
    <SetOnlineTime
      :dialog-info="setOnlineDialog"
      @close="closeSet"
      :videoSetUuids="videoSetIds"
    />
    <PortSelect
      :dialogInfo="portDialogInfo"
      @close="closePort"
      v-if="portDialogInfo.show"
      :api="updateDisplay"
    />
  </div>
</template>
<script>
import {
changeOnlineStatus,
exportVideoSetList,
updateDisplay,
videoSetDelete,
videoSetList
} from "@/api/videoSet";
import { Alert } from "@/components/Confirm";
import butn from "@/components/button/index";
import RCPagination from "@/components/pagination/paginationManage";
import PortSelect from "@/pages/video/portSelect.vue";
import store from "@/store";
import { IS_SHOW_SHARED_KEY } from "@/utils/constants.js";
import BatchDeal from "@/views/onlineClass/teaching/content/batchDeal.vue";
import VueQr from "vue-qr";
import { getItem, removeItem } from "../../utils/storage";
import Bus from "./Bus.js";
import Details from "./details";
import OneClickShare from "./oneClickShare/index";
import Search from "./search";
import SetOnlineTime from "./setOnlineTime.vue";
import ShareManage from "./share/index";
import Tables from "./table.js";
import Warrant from "./warrant.vue";
import ExcelImport from "@/components/exceImport"
import { offlineVideoSetTemplate } from "@/assets/excel/index.js";
import { importOfflineVideoSet } from "@/api/resourceService/index.js"

export default {
  name: "videoSet",
  components: {
    Tables,
    butn,
    Search,
    RCPagination,
    Details,
    Warrant,
    ShareManage,
    OneClickShare,
    BatchDeal,
    VueQr,
    SetOnlineTime,
    PortSelect,
    ExcelImport
  },
  data() {
    let batchData = [];
    const permissionList = store.getters.permissionList["videoSet"];
    if (permissionList && permissionList.includes("videoSet:online")) {
      batchData.push({
        paramValue: "批量上线",
        paramKey: "1",
        way: "batchOnline",
      });
      batchData.push({
        paramValue: "批量下线",
        paramKey: "2",
        way: "batchOffline",
      });
    }
    if (permissionList && permissionList.includes("videoSet:delete")) {
      batchData.push({
        paramValue: "批量删除",
        paramKey: "3",
        way: "batchDel",
      });
    }
    if (permissionList && permissionList.includes("videoSet:online")) {
      batchData.push({
        paramValue: "批量设置上线时间",
        paramKey: "4",
        way: "batchSetOnlineTime",
      });
    }
    return {
      updateDisplay,
      IS_SHOW_SHARED_KEY,
      size: "small",
      filters: {
        name: "",
      },
      videoSetList: [],
      api: videoSetList,
      selections: [], // 列表选中列
      dialogFormVisible: false,
      dataname: "",
      batchData,
      qrcodeItem: {},
      qrData: null,
      setOnlineDialog: {
        show: false,
      },
      portDialogInfo: {
        show: false,
        isApp: 0,
        isWeb: 0,
        isPc: 0,
        isApplet: 0,
        uuid: "",
      },
      offlineVideoSetTemplate: offlineVideoSetTemplate,
      importOfflineVideoSet: importOfflineVideoSet,
    };
  },
  methods: {
    changePort(item) {
      const { isApp = 0, isWeb = 0, isPc = 0, isApplet = 0, uuid = "" } = item;
      this.portDialogInfo = {
        show: true,
        isApp,
        isWeb,
        isPc,
        isApplet,
        uuid,
      };
    },
    closePort(flag) {
      if (flag) {
        this.$refs["pagination"].search(this.dataname);
      }
      this.portDialogInfo.show = false;
    },
    async confirmWay(msg) {
      try {
        const flag = await this.$confirm(msg, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        return flag !== "confirm";
      } catch (e) {
        return true;
      }
    },
    dealResult({ code, msg }) {
      if (code !== 0) return;
      this.$message.success(msg);
      this.$refs["pagination"].search(this.dataname);
    },
    async batchOnline() {
      if (await this.confirmWay("确认要上线已选中视频集吗?")) return;
      changeOnlineStatus({ uuids: this.videoSetIds, onlineStatus: 1 }).then(
        (res) => this.dealResult(res)
      );
    },
    async batchOffline() {
      if (await this.confirmWay("确认要下线已选中视频集吗?")) return;
      changeOnlineStatus({ uuids: this.videoSetIds, onlineStatus: 0 }).then(
        (res) => {
          if (res.code == 2011) {
            Alert(res.msg, '系统提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
            return;
          } else this.dealResult(res);
        }
      );
    },
    async batchDel() {
      if (await this.confirmWay("确认要删除已选中视频集吗?")) return;
      videoSetDelete({ uuids: this.videoSetIds }).then((res) =>
        this.dealResult(res)
      );
    },
    batchSetOnlineTime() {
      this.setOnlineDialog.show = true;
    },
    closeSet(flag = false) {
      if (flag) {
        this.$refs["pagination"].search(this.dataname);
      }
      this.setOnlineDialog.show = false;
    },
    batchDeal(way) {
      this[way]();
    },
    handleAdd() {
      Bus.$emit("ReceiveMessage", "");
    },
    oneClickShare() {
      Bus.$emit("oneClickShare", this.videoSetIds);
    },
    selectionChange: function (selections) {
      this.selections = selections;
    },
    //上下线
    changeOnlineStatus(data, status) {
      this.$confirm(
        `${status == 1 ? "确认要上线该视频集吗?" : "确认要下线该视频集吗？"}`,
        "系统提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.loading = true;
          changeOnlineStatus({ uuids: [data.uuid], onlineStatus: status })
            .then((res) => {
              if (res.code == 2011) {
                Alert(res.msg, '系统提示', {
                  confirmButtonText: '确定',
                  callback: action => {}
                });
                return;
              } else if (res && res.code == 0) {
                this.$message.success(res.msg);
                this.$refs["pagination"].search(this.dataname);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //删除
    deleteData(data) {
      this.$confirm(`确认要删除该视频集吗?`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          videoSetDelete({ uuids: [data.uuid] })
            .then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                this.$refs["pagination"].search(this.dataname);
              }
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {});
    },
    //搜索
    searchHandle(param = {}) {
      this.dataname = { ...param };
      this.$refs["pagination"].search(this.dataname);
    },
    searchl() {
      this.$refs["pagination"].search();
    },
    search(data) {
      this.$refs["pagination"].search(data);
    },
    downloadQrcode(val) {
      const a = document.createElement("a");
      const event = new MouseEvent("click");
      a.download = this.qrcodeItem.videoSetName;
      a.href = val;
      a.dispatchEvent(event);
    },

    qrCallBack(dataUrl, id) {
      this.qrData = dataUrl;
      if (id && id == this.qrcodeItem.uuid) {
        this.downloadQrcode(dataUrl);
      }
    },

    exportExcel() {
      // 下载清单
      let param = { ...this.dataname };
      exportVideoSetList(param).then((response) => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function () {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error",
              });
            }
          } catch (e) {
            let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
      })
    },
    //导入下线视频集成功回调
    importSuccess() {

    },
  },
  created() {
    var _this = this;
    Bus.$on("deleteVideoSet", function (item) {
      _this.deleteData(item);
    });
    Bus.$on("upLine", function (item) {
      _this.changeOnlineStatus(item, 1);
    });
    Bus.$on("downLine", function (item) {
      _this.changeOnlineStatus(item, 0);
    });
    Bus.$on("reload", () => {
      this.$refs["pagination"].search(this.dataname);
    });
    Bus.$on("qrcodeClick", (data) => {
      if (data.uuid != this.qrcodeItem.uuid) {
        this.qrcodeItem = data;
      } else {
        this.downloadQrcode(_this.qrData);
      }
    });
  },

  activated() {
    if (getItem(this.REFRESH_FLAG)) {
      this.searchHandle(this.dataname);
      removeItem(this.REFRESH_FLAG);
    }
  },

  computed: {
    roleIds() {
      return this.selections.map((item) => item.roleId);
    },
    videoSetIds() {
      return this.selections.map((item) => item.uuid);
    },
    unShareVideoSets() {
      return this.selections.filter((item) => item.enableShared == 0);
    },
  },
  mounted() {},
};
</script>
